var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.ready)?_c('div',[_c('fe-spinner',{staticClass:"spinner"})],1):_c('highcharts',{ref:"launchpad-incident-range-chart",staticClass:"fe-chart",attrs:{"options":_vm.charts[0].config}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }